import { render, staticRenderFns } from "./ThePasteRecipientsTable.vue?vue&type=template&id=6376a158&scoped=true"
import script from "./ThePasteRecipientsTable.vue?vue&type=script&lang=js"
export * from "./ThePasteRecipientsTable.vue?vue&type=script&lang=js"
import style0 from "./ThePasteRecipientsTable.vue?vue&type=style&index=0&id=6376a158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376a158",
  null
  
)

export default component.exports